import Vue from 'vue'
import Vuex from 'vuex'
import gateways from './Modules/gateways' //"m" en lugar de "M"
import meters from './Modules/meters' //"m" en lugar de "M"
import graphs from './Modules/graphs' //"m" en lugar de "M"
import user from './Modules/user' //"m" en lugar de "M"
import schedules from './Modules/schedules' //"m" en lugar de "M"

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        gateways,
        meters,
        graphs,
        user,
        schedules
    },
})
